module.exports = __webpack_public_path__ + "static/image/company/m/image_better@3x.jpg?fcfdb2a7";